export const SkeletonTable = () => (
  <>
    <div className="skeleton-table">
      <div className="skeleton-row skeleton-header"></div>
      {[...Array(4)].map((_, i) => (
        <div className="skeleton-row" key={i}></div>
      ))}
    </div>
    <style>
      {`
            .skeleton-table {
                width: 100%;
                margin-bottom: 1rem;
            }
            .skeleton-row {
                height: 32px;
                background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                background-size: 200% 100%;
                animation: skeleton-loading 1.2s infinite linear;
                border-radius: 4px;
                margin-bottom: 8px;
            }
            .skeleton-header {
                height: 36px;
                width: 80%;
                margin: 0 auto 12px auto;
            }
            @keyframes skeleton-loading {
                0% {
                    background-position: 200% 0;
                }
                100% {
                    background-position: -200% 0;
                }
            }
        `}
    </style>
  </>
);
